export const Burger = ((selector = ".burger") => {
	const toggleMenu = (button) => {
		const currentState = button.getAttribute("data-state");
		const target = button.getAttribute("aria-controls");
		const targetElement = document.querySelector(`#${target}`);

		if (!targetElement) return;

		const isOpen = currentState === "opened";

		button.setAttribute("data-state", isOpen ? "closed" : "opened");
		button.setAttribute("aria-expanded", !isOpen);
		targetElement.parentElement.classList.toggle("is-open", !isOpen);
	};

	const init = () => {
		const buttonsBurger = document.querySelectorAll(selector);

		if (!buttonsBurger.length) return;

		buttonsBurger.forEach((button) => {
			button.addEventListener("click", () => toggleMenu(button));
		});
	};

	return {
		init: init,
	};
})();
